import { JSX, Show } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { upiLogoLongListMobile } from "~/assets/assets";
import { toRupees } from "~/utils/number";
import { goBack } from "~/shared_states/modal";
import { PhosphorIcon } from "~/widgets/icons";
import { usePaymentLoaderContext } from "../context/payment_loader_context";

const ArrowRightIcon = () => (
  <PhosphorIcon name="arrow-right" fontSize={20} class="text-white" />
);

export function AndroidUpiView(): JSX.Element {
  const { components } = useTelescopeContext();
  const { amount, showProcessingLoader, launchDefaultUpiIntent } =
    usePaymentLoaderContext();

  return (
    <div class="relative flex flex-col overflow-hidden bg-background-normal-primary">
      {/* Header */}
      <components.ModalHeader
        size="large"
        title={toRupees(amount)}
        description="Scan & pay via any UPI app"
        onClose={goBack}
      />

      {/* Content */}
      <div class="flex flex-col items-center gap-6 px-5 pb-6 pt-5">
        {/* UPI logos container */}
        <div class="flex w-full flex-col items-center gap-4 rounded-xl bg-background-normal-tertiary px-0 py-4">
          <div class="flex w-[295px] flex-col items-center gap-4">
            <img
              src={upiLogoLongListMobile}
              alt="UPI apps - GPay, PhonePe, Paytm, CRED, BHIM"
              class="h-16 w-full object-contain"
            />
            <div class="flex items-center justify-center gap-2">
              <p class="text-center text-para-3-regular tracking-[-0.14px] text-text-normal-secondary">
                <Show when={showProcessingLoader()} fallback="Pay via UPI">
                  Processing payment
                </Show>
              </p>
              <Show when={showProcessingLoader()}>
                <components.Loader size="small" />
              </Show>
            </div>
          </div>
        </div>

        {/* Select UPI App Button */}
        <Show
          when={!showProcessingLoader()}
          fallback={
            <components.Button
              text="Cancel payment"
              variant="secondary"
              style="neutral"
              size={40}
              expanded
              onClick={() => goBack()}
            />
          }
        >
          <components.Button
            text="Select UPI app to pay"
            variant="primary"
            style="neutral"
            size={40}
            expanded
            onClick={launchDefaultUpiIntent}
            TrailIcon={ArrowRightIcon}
          />
        </Show>
      </div>

      {/* Footer */}
      <div class="flex flex-col items-center gap-4 pb-6">
        <div class="h-px w-full bg-[#edeef1]" />
        <div class="px-6">
          <p class="text-center text-para-3-regular tracking-[-0.14px] text-text-normal-secondary">
            Note: You'll be redirected to another page once payment is
            processed.
          </p>
        </div>
      </div>
    </div>
  );
}
